// SQLite normalizer — routes SQLite connections through the per-dialect
// tree-sitter grammar fork (resources/tree-sitter/sqlite.wasm) instead of the
// legacy unified scanner. PRD: Ralph/SqlGrammar2/PRD.md Slice 5.5.
//
// Binds the `createForkNormalizer` factory (extracted in Slice 3.5 at n=3
// forks; confirmed at n=4 in Slice 4.5) to the SQLite parser singleton. n=5
// finality for the factory pattern — single-token engine-type widening only.

import { createForkNormalizer } from '../shared/createForkNormalizer';
import { getSqliteParser } from './parser';

const normalizer = createForkNormalizer({ engine: 'sqlite', getParser: getSqliteParser });

export const buildParsedDocument = normalizer.buildParsedDocument;
export const getDocumentStructure = normalizer.getDocumentStructure;

export { setSqliteWasmLoader, getSqliteParser, __resetSqliteParserForTest } from './parser';
export type { SqliteWasmLoader } from './parser';
